'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReadalikePlaceholder = function (_BcReactComponent) {
  _inherits(ReadalikePlaceholder, _BcReactComponent);

  function ReadalikePlaceholder(props) {
    _classCallCheck(this, ReadalikePlaceholder);

    var _this = _possibleConstructorReturn(this, (ReadalikePlaceholder.__proto__ || Object.getPrototypeOf(ReadalikePlaceholder)).call(this, props));

    _this.bindAll('validateImage', 'renderAnchorBib');
    _this.state = { showAnchorBibPlaceholder: true };
    return _this;
  }

  _createClass(ReadalikePlaceholder, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.validateImage(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.anchorBibSrc !== nextProps.anchorBibSrc) {
        this.setState({ showAnchorBibPlaceholder: true });
        this.validateImage(nextProps);
      }
    }
  }, {
    key: 'validateImage',
    value: function validateImage(newProps) {
      var _this2 = this;

      var src = newProps.anchorBibSrc;
      if (src) {
        var testImage = new Image();
        testImage.onload = function () {
          _this2.setState({
            showAnchorBibPlaceholder: testImage.width <= 1 || testImage.height <= 1
          });
        };
        testImage.src = src;
      }
    }
  }, {
    key: 'renderAnchorBib',
    value: function renderAnchorBib() {
      var anchorBibSrc = this.props.anchorBibSrc;

      if (this.state.showAnchorBibPlaceholder) {
        return _react2.default.createElement(
          'g',
          null,
          _react2.default.createElement('rect', { fill: '#FFFFFF', x: '24', y: '15', width: '112', height: '174' }),
          _react2.default.createElement('rect', { fill: '#E5E5E5', x: '26', y: '17', width: '108', height: '170' })
        );
      }

      return _react2.default.createElement('image', {
        stroke: '#E5E5E5',
        strokeWidth: '1',
        xlinkHref: anchorBibSrc,
        x: '26', y: '17',
        width: '108',
        height: '170',
        preserveAspectRatio: 'xMidYMin' });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        {
          className: 'cp-user-list-jacket-cover-readalike-placeholder',
          viewBox: '0 0 232 275',
          focusable: 'false',
          'aria-hidden': 'true' },
        _react2.default.createElement(
          'g',
          { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
          _react2.default.createElement(
            'g',
            { transform: 'translate(-24.000000, -15.000000)' },
            this.renderAnchorBib(),
            _react2.default.createElement('rect', { fill: '#FFFFFF', x: '144', y: '43', width: '52', height: '76' }),
            _react2.default.createElement('rect', { fill: '#FFFFFF', x: '24', y: '197', width: '52', height: '88' }),
            _react2.default.createElement('rect', { fill: '#FFFFFF', x: '84', y: '197', width: '52', height: '93' }),
            _react2.default.createElement('rect', { fill: '#FFFFFF', x: '144', y: '201', width: '52', height: '84' }),
            _react2.default.createElement('rect', { fill: '#FFFFFF', x: '144', y: '127', width: '52', height: '66' }),
            _react2.default.createElement('rect', { fill: '#FFFFFF', x: '204', y: '219', width: '52', height: '66' }),
            _react2.default.createElement('rect', { fill: '#FFFFFF', x: '204', y: '43', width: '52', height: '84' }),
            _react2.default.createElement('rect', { fill: '#FFFFFF', x: '204', y: '135', width: '52', height: '76' }),
            _react2.default.createElement('rect', { fill: '#E5E5E5', x: '146', y: '45', width: '48', height: '72' }),
            _react2.default.createElement('rect', { fill: '#E5E5E5', x: '26', y: '199', width: '48', height: '84' }),
            _react2.default.createElement('rect', { fill: '#E5E5E5', x: '86', y: '199', width: '48', height: '89' }),
            _react2.default.createElement('rect', { fill: '#E5E5E5', x: '146', y: '203', width: '48', height: '80' }),
            _react2.default.createElement('rect', { fill: '#E5E5E5', x: '146', y: '129', width: '48', height: '62' }),
            _react2.default.createElement('rect', { fill: '#E5E5E5', x: '206', y: '221', width: '48', height: '62' }),
            _react2.default.createElement('rect', { fill: '#E5E5E5', x: '206', y: '45', width: '48', height: '80' }),
            _react2.default.createElement('rect', { fill: '#E5E5E5', x: '206', y: '137', width: '48', height: '72' })
          )
        )
      );
    }
  }]);

  return ReadalikePlaceholder;
}(_baseBcReactComponent2.default);

exports.default = ReadalikePlaceholder;


ReadalikePlaceholder.propTypes = {
  anchorBibSrc: _react.PropTypes.string
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/list-jacket-cover/components/ReadalikePlaceholder.component.js
// module id = 1312
// module chunks = 0